/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_NewInputs */

const cs_templates_new = /** @type {(inputs: Templates_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová šablona`)
};

const en_templates_new = /** @type {(inputs: Templates_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New template`)
};

/**
* | output |
* | --- |
* | "New template" |
*
* @param {Templates_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_new = /** @type {((inputs?: Templates_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_new(inputs)
	return cs_templates_new(inputs)
});